import React, { useEffect, useState, forwardRef } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"

function ucfirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

const DebitCreditDrops = forwardRef(
  ({ control, name, onSelectChange, target, placeholder }, selectRef) => {
    const [isLoading, setIsLoading] = useState(true)
    const [countriesData, setCountriesData] = useState([])

    const loadOptions = async () => {
      const data = [
        { label: "Dr", value: "debit" },
        { label: "Cr", value: "credit" },
      ]
      setIsLoading(false)
      setCountriesData(
        data.map(dta => ({
          label: ucfirst(dta.label),
          value: dta.value,
        }))
      )
    }

    useEffect(() => {
      loadOptions()
    }, [])

    return (
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <Select
            ref={selectRef}  // Forwarded ref here
            options={countriesData}
            placeholder={
              <div className="placeholder-custome-issue">
                {placeholder || "Select"}
              </div>
            }
            isLoading={isLoading}
            onChange={e => {
              onChange(e)
              if (onSelectChange) onSelectChange(e)
            }}
            value={value}
            classNamePrefix="react-select"
            className="elevate-dropdown"
            menuPortalTarget={document.body}
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          />
        )}
      />
    )
  }
)

export default DebitCreditDrops
